/** Preserve clinical subsection append/overwrite choices when filling one merged answer. */
export function parallelSectionReplyType(question, templateValue, defaultReplyType) {
  if (!question?.ParallelSections?.length) return defaultReplyType;
  let parsed;
  try {
    parsed = typeof templateValue === 'string' ? JSON.parse(templateValue) : templateValue;
  } catch {
    return defaultReplyType;
  }
  const subsections = {};
  for (const name of question.ParallelSections) {
    subsections[name] = parsed?.SubSections?.[name]?.replyType || defaultReplyType;
  }
  return { defaultReplyType, subsections };
}
